import { render, staticRenderFns } from "./myappeal.vue?vue&type=template&id=31a6e304&scoped=true"
import script from "./myappeal.vue?vue&type=script&lang=js"
export * from "./myappeal.vue?vue&type=script&lang=js"
import style0 from "./myappeal.vue?vue&type=style&index=0&id=31a6e304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6e304",
  null
  
)

export default component.exports